"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    fillRule: "evenodd",
    clipRule: "evenodd",
    width: props.size || props.width || "24px",
    id: "aani",
    height: props.size || props.height || "24px"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "transparent",
    d: "M-.5-.5h30v28h-30v-28z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "transparent",
    d: "M19.5 8.5c-4.14.544-4.806-.456-2-3 .283-.79.783-1.456 1.5-2 .494 1.634.66 3.3.5 5z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#eace7c",
    d: "M16.5 3.5c-.172.992.162 1.658 1 2-2.806 2.544-2.14 3.544 2 3-1.889 1.242-3.889 1.242-6 0 .61-1.934 1.61-3.6 3-5z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#f4e8c9",
    d: "M21.5 2.5c.961 1.765 1.295 3.765 1 6 1.478-.262 2.811.071 4 1-.82 1.611-2.154 2.278-4 2 .317 4.202-.017 8.202-1 12v-10-3c4-.333 4-.667 0-1v-7z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#dcb54b",
    d: "M21.5 2.5v7c4 .333 4 .667 0 1-5.676-.166-11.343 0-17 .5.544.717 1.21 1.217 2 1.5 0 .667.333 1 1 1 .79.901 1.79 1.568 3 2 2.622 2.282 5.288 4.615 8 7a9.864 9.864 0 001-6l2-3v10c-.311.978-.978 1.645-2 2a69.233 69.233 0 01-9-7 22.853 22.853 0 01-4-3c-2.683-1.17-3.85-3.17-3.5-6 3.394-.956 6.894-1.29 10.5-1 2.111 1.242 4.111 1.242 6 0 .16-1.7-.006-3.366-.5-5-.717.544-1.217 1.21-1.5 2-.838-.342-1.172-1.008-1-2 1.377-3.226 3.043-3.56 5-1z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "transparent",
    d: "M7.5 13.5c-.667 0-1-.333-1-1 1.1-1.098 2.434-1.265 4-.5-.744 1.039-1.744 1.539-3 1.5z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#e5cc86",
    d: "M21.5 10.5v3l-2 3v-5c-4.048-.67-7.048.663-9 4-1.21-.432-2.21-1.099-3-2 1.256.039 2.256-.461 3-1.5-1.566-.765-2.9-.598-4 .5-.79-.283-1.456-.783-2-1.5 5.657-.5 11.324-.666 17-.5z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "transparent",
    d: "M19.5 16.5a9.864 9.864 0 01-1 6 2079.824 2079.824 0 00-8-7c1.952-3.337 4.952-4.67 9-4v5z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#e1cba3",
    d: "M6.5 15.5a22.853 22.853 0 004 3c-2.41.42-4.243 1.754-5.5 4 .14-2.351.64-4.684 1.5-7z"
  }));
};
var _default = exports["default"] = SvgComponent;